import $ from "jquery";
import toggleClass from "../utils/toggleClass";

function headerButton() {
  let button = document.querySelector(".site-header__mobule-button");
  if (button) {
    button.addEventListener("click", function () {
      window.scrollTo(0, 0);
      this.classList.toggle("active");
      document.body.classList.toggle("disable-scroll");
      document.documentElement.classList.toggle("disable-scroll");
      toggleClass(".site-header", "active");
      toggleClass(".site-header__content-block", "active");

      // hide promo banner
      // toggleClass(".promo-popup-banner", "disable")
    });
  } else {
    console.warn("Mobile navigation button is not available");
  }
}

function headerNavigationDropdown() {
  let navItems = document.querySelectorAll(
    ".site-header__navigation-list-item.dropdown"
  );
  if (navItems.length > 0) {
    navItems.forEach((element) => {
      element.addEventListener("click", function () {
        this.classList.toggle("dropdown_active");
      });
    });
  } else {
    console.warn("dropdown elements on navigation list are not available");
  }
}

export function openSenturoModal(isBtnClicked=false) {
  const firstTime = localStorage.getItem("show-alert");
  if (!firstTime || isBtnClicked) {
    $(".senturo-alert-modal").addClass("modal--open");
    $(document.body).addClass("modal-active");
  }
  localStorage.setItem("show-alert", true);
}

function solutionAction() {
  $(".open-senturo").click(function () {
    openSenturoModal(true);
  });
  $(".senturo__modal-close, .stay-hiddenapp-btn").on("click", () => {
    $(".senturo-alert-modal").removeClass("modal--open");
    $(document.body).removeClass("modal-active");
  });
}

function header() {
  headerButton();
  headerNavigationDropdown();
  solutionAction();
}

export default header;
